<template lang="pug">
.VersionStateIcon(
  :class="{'VersionStateIcon--link': state === 'outdated'}"
)
  van-icon(
    :class="{'az-icon--rotate': stateInfo.icon === 'update'}"
    :name="stateInfo.icon"
    :font-size="stateInfo.fontSize"
    :color="stateInfo.color"
  )
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      default: 'success',
      validator: value => ['success', 'outdated', 'loading'].indexOf(value) !== -1,
    },
  },

  computed: {
    stateInfo() {
      let color = '#44db5e';
      let icon = 'check';
      let fontSize = '1.4em';

      if (this.state === 'loading') {
        icon = 'update';
        color = '#09c';
        fontSize = '1.4em';
      } else if (this.state === 'outdated') {
        icon = 'download';
        color = '#09c';
        fontSize = '1.4em';
      }
      return {
        color,
        icon,
        fontSize,
      };
    },
  },
};
</script>
